import { useEffect, useRef, useState } from 'react';
import { ProTableOt, Toaster, toast, Row, Col, Button, useProTableOt, Form, Modal, message, Label, Input, Select, ResizablePanelGroup, ResizablePanel, ResizableHandle } from '../../ui/ot'
import { useBorrower } from '../controllers/BorrowerController';
import dayjs from 'dayjs'
import { Link } from 'react-router-dom';
import { useCheckout } from '../controllers/CheckoutController';
import { useItem } from "../controllers/ItemController";
import { useTranslation } from 'react-i18next';
import CheckoutSettingModal, { CheckoutSettingForm } from './CheckoutSettingModal';


const CheckoutSettingProTableOt = ({
    keyPrefix = "library.backstage.Circulation.CheckoutSetting.items",
    borrowernumber: borrowernumber,
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    // propsRowKey = "item_itemnumber",
    propsRowKey = "key",
    propsForm,
    customColumns = [],
    customFormItems = () => { },
    extraActionRender = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsUseCheckout = useCheckout,
    propsUseItem = useItem,
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    onSelectChange = () => { },
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const actionRef = useRef()
    const actionRef_patron = useRef()
    const actionRef_item = useRef()
    const [extra_columns, set_extra_columns] = useState([]);
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [form_] = Form.useForm();
    const form = propsForm ?? form_;
    const [axiosMode, setAxiosMode] = useState("get")

    const [inputBorrowerCardnumber, setInputBorrowerCardnumber] = useState("");
    const [inputItemBarcode, setInputItemBarcode] = useState("")
    const [inputBiblionumber, setInputBiblionumber] = useState("")
    const refBorrowerCardnumber = useRef("");
    const refItemBarcode = useRef("");
    const [loading, setLoading] = useState(false)
    const [clear_input, set_clear_input] = useState(false)
    const [borrower_data, set_borrower_data] = useState([]);
    const [item_data, set_item_data] = useState([]);
    const [search, set_search] = useState(false);

    const original_columns = [
        {
            title: t("due_date"),
            dataIndex: 'issue_date_due',
            key: 'issue_date_due',
            render: (text) => {
                return <>{dayjs(text).format('YYYY-MM-DD')}</>
            }
        },
        {
            title: t("title"),
            dataIndex: 'bib_title',
            key: 'bib_title',
            render: (text, record) => {
                return <>
                <Row>
                    <Col span={24}>
                    <Link to={'/library/backstage/AddItem/' + record?.bib_biblionumber} style={{ color: 'blue' }}>{text}{record?.bib_subtitle}</Link>{record?.bib_author}
                    </Col>
                    <Col span={24}>
                    <Link to={'/library/backstage/BookDetailItems/' + record?.item_itemnumber} style={{ color: 'blue' }}>{record?.item_barcode}</Link>
                    </Col>
                </Row>
                </>
            }
        },
        {
            title: t("category"),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t("collection"),
            dataIndex: 'collection',
            key: 'collection',
        },
        {
            title: t("location"),
            dataIndex: 'item_location',
            key: 'item_location',
        },
        {
            title: t("original_library"),
            dataIndex: 'item_branchname',
            key: 'item_branchname',
        },
        {
            title: t("borrow_date"),
            dataIndex: 'issue_issuedate',
            key: 'issue_issuedate',
        },
        {
            title: t("borrow_library"),
            dataIndex: 'issue_branchname',
            key: 'issue_branchname',
        },
        {
            title: t("fee"),
            dataIndex: 'issue_charge',
            key: 'issue_charge',
        },
        {
            title: t("fine"),
            dataIndex: 'issue_accountlines_amount',
            key: 'issue_accountlines_amount',
        },
        {
            title: t("price"),
            dataIndex: 'item_purchase_price',
            key: 'item_purchase_price',
        },
        // {
        //     title: t("checkin_renew"),
        //     dataIndex: 'returnBook',
        //     key: 'returnBook',
        //     render: (_, record) => {
        //         return <>
        //             <Row gutter={[8, 8]}>
        //                 <Col>
        //                     <Button variant="destructive" onClick={() => CheckIn({ record })}>{t("return")}</Button>
        //                 </Col>
        //                 <Col>
        //                     <Button variant="outline" disabled={record?.issue_renewals_allow === record?.issue_renewals_count} onClick={() => Renew({ record })}>{t("renew")}</Button>
        //                 </Col>
        //             </Row>
        //             {extraActionRender(record)}
        //         </>
        //     }
        // },
        ...customColumns,
    ];
    const columns = [
        {
            title: t("biblionumber"),
            dataIndex: 'bib_biblionumber',
            key: 'bib_biblionumber',
        },
        {
            title: t("itemnumber"),
            dataIndex: 'item_itemnumber',
            key: 'item_itemnumber',
        },
        {
            title: t("collection_type"),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t("title"),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: "20rem",
            render: (text, record) => {
                return <>
                <Row>
                    {/* <Col span={24}>
                    <Link to={'/library/backstage/AddItem/' + record?.bib_biblionumber} style={{ color: 'blue' }}>{text}{record?.bib_subtitle}</Link>{record?.bib_author}
                    </Col>
                    <Col span={24}>
                    <Link to={'/library/backstage/BookDetailItems/' + record?.item_itemnumber} style={{ color: 'blue' }}>{record?.item_barcode}</Link>
                    </Col> */}
                    <Col span={24}>{text}</Col>
                    <Col span={24}>{record?.bib_subtitle}</Col>
                    <Col span={24}>{record?.bib_author}</Col>
                    <Col span={24}>{record?.item_barcode}</Col>
                </Row>
                </>
            }
        },
        {
            title: t("barcode"),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: t("collection_branch"),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t("current_location"),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: t("call_number"),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: t("copy_id"),
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        },
        {
            title: t("checkout"),
            dataIndex: 'checkout',
            key: 'checkout',
            render: (_, record) => {
                return <>
                    <Row gutter={[8, 8]}>
                        <Col>
                            {/* <Button variant="outline" disabled={record?.issue_renewals_allow === record?.issue_renewals_count} onClick={() => Renew({ record })}>{t("checkout")}</Button> */}
                            <Button variant="outline" onClick={() => handleEditRow(record)}>{t("checkout")}</Button>
                        </Col>
                    </Row>
                    {extraActionRender(record)}
                </>
            }
        },
        ...customColumns,
    ];
    const columns_patron = [
        {
            title: '編號(系統帳號)',
            key: 'staff_serial_name',
            dataIndex: 'staff_serial_name',
            align: 'center',
        },
        {
            title: '姓名',
            key: 'staff_name',
            dataIndex: 'staff_name',
            align: 'center',
        },
        {
            title: '英文名',
            key: 'staff_english_name',
            dataIndex: 'staff_english_name',
            align: 'center',
        },
        {
            title: '性別',
            key: 'gender_name',
            dataIndex: 'gender_name',
            align: 'center',
        },
        {
            title: '更多資訊',
            key: 'property_json',
            dataIndex: 'property_json',
            align: 'center',
            // render: (text) => <>
            //     <Row>
            //         {Object.keys(text).map(item => <Col span={24}>{item}：{text[item]}</Col>)}
            //     </Row>
            // </>
        },
        {
            title: t('borrowernumber'),
            key: 'borrowernumber',
            dataIndex: 'borrowernumber',
            align: 'center',
        },
        {
            title: t('cardnumber'),
            key: 'cardnumber',
            dataIndex: 'cardnumber',
            align: 'center',
        },
        {
            title: t('branchcode'),
            key: 'branchcode',
            dataIndex: 'branchcode',
            align: 'center',
        },
        {
            title: t('branchname'),
            key: 'branchname',
            dataIndex: 'branchname',
            align: 'center',
        },
        {
            title: t('borrowercategory'),
            key: 'categoryname',
            dataIndex: 'categoryname',
            align: 'center',
        },
    ];
    const columns_item = [
        {
            title: t("itemnumber"),
            dataIndex: 'item_itemnumber',
            key: 'item_itemnumber',
        },
        {
            title: t("collection_id"),
            dataIndex: 'item_itemnumber',
            key: 'item_itemnumber',
        },
        {
            title: t("collection_type"),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t("title"),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: "20rem",
            render: (text, record) => {
                return <>
                <Row>
                    <Col span={24}>{text}</Col>
                    <Col span={24}>{record?.bib_subtitle}</Col>
                    <Col span={24}>{record?.bib_author}</Col>
                    <Col span={24}>{record?.item_barcode}</Col>
                </Row>
                </>
            }
        },
        {
            title: t("barcode"),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: t("collection_branch"),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t("current_location"),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: t("call_number"),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: t("copy_id"),
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        },
    ];

    const setParamsFilter = (obj) => {
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        form.resetFields()
        form.setFieldsValue({
            itemnumber: record?.item_itemnumber, 
            biblionumber: record?.bib_biblionumber, 
        })
    }

    const onFormFinish = (values) => {
        let body = {
            borrowernumber: values?.borrowernumber, 
            itemnumber: values?.itemnumber,
            biblionumber: values?.biblionumber,
            // ...values,
            // due_date: dayjs(values?.due_date).format("YYYY-MM-DD HH:mm:ss"),
        }
        if (axiosMode === "post") {
            postCheckoutData([body])
            // postCheckoutSettingData([values])
        }
        else if (axiosMode === "patch") {
            postCheckoutData([body])
            // patchCheckoutSettingData([values])
        }
    }

    const onCheckoutFinish = ({ axiosMode, status, values }) => {
        propsOnFinish({ axiosMode, status, values })
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();
                set_borrower_data([])
                set_item_data([])
                set_search(false)
                setInputBorrowerCardnumber("")
                setInputItemBarcode("")
                set_clear_input(true)
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reload();
                set_borrower_data([])
                set_item_data([])
                set_search(false)
                setInputBorrowerCardnumber("")
                setInputItemBarcode("")
                set_clear_input(true)
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                // message.error("新增失敗")
                if(values === "Confirmation error") {
                    if(item_data?.find(_ => true)?.reserve.length > 0) {
                        Modal.confirm({
                            width: 500,
                            title: t('checkout'),
                            content: <>此館藏已被借閱或是預約<br />請改為預約此館藏</>,
                            onOk: () => {
                                actionRef.current.reload();
                                setSelectedRowKeys([])
                                setSelectedRowsInfo([])
                            },
                            okText: t('ok'),
                            cancelText: t('cancel'),
                        })
                    }
                    else message.error("借閱失敗，此讀者借閱次數已達上限")
                }
                else if (values === "Checkout not authorized (NO_MORE_RENEWALS)"){
                    Modal.confirm({
                        width: 500,
                        title: t('checkout'),
                        content: <>此館藏已被使用者借閱，且尚未到開放續借時間<br />請到開放續借時間時再續借<br />或者請改為預約此館藏</>,
                        onOk: () => {
                            actionRef.current.reload();
                            setSelectedRowKeys([])
                            setSelectedRowsInfo([])
                        },
                        okText: t('ok'),
                        cancelText: t('cancel'),
                    })
                }
                else if (values === "Checkout not authorized (EXPIRED)"){
                    Modal.confirm({
                        width: 500,
                        title: t('checkout'),
                        content: <>此讀者帳號已過期，請先更新帳號期限</>,
                        onOk: () => {
                            actionRef.current.reload();
                            setSelectedRowKeys([])
                            setSelectedRowsInfo([])
                        },
                        okText: t('ok'),
                        cancelText: t('cancel'),
                    })
                }
                else if (values === "Expected integer - got string."){
                    Modal.confirm({
                        width: 500,
                        title: t('checkout'),
                        content: <>請輸入數字</>,
                        onOk: () => {
                            actionRef.current.reload();
                            setSelectedRowKeys([])
                            setSelectedRowsInfo([])
                        },
                        okText: t('ok'),
                        cancelText: t('cancel'),
                    })
                }
                else {
                    Modal.confirm({
                        width: 500,
                        title: t('checkout'),
                        content: <>此館藏已被借閱或是預約<br />請改為預約此館藏</>,
                        onOk: () => {
                            actionRef.current.reload();
                            setSelectedRowKeys([])
                            setSelectedRowsInfo([])
                        },
                        okText: t('ok'),
                        cancelText: t('cancel'),
                    })
                }
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
    }
    const onCheckoutBefore = ({ axiosMode, status, values }) => {
        propsOnBefore({ axiosMode, status, values })
        // setModalLoading(true)
    }

    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedRowsKeys)
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedRowsInfo)
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.[propsRowKey])
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.[propsRowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record?.[propsRowKey])
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record?.[propsRowKey])
                selectRow = selectRow.filter(row => row?.[propsRowKey] !== record?.[propsRowKey])
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    
    const { check, setCheck, checkAll, setOrders, custom_filter_key } = useTableColumnsCheck(columns);


    const {
        ItemData,
        getItemData,
        SpecificItemData, 
        getSpecificItemData,
        ItemBiblionnumberData, 
        getItemBiblionData, 
    } = propsUseItem({

    })
    const {
        BorrowerData,
        getBorrowerData,
    } = useBorrower({
        onBefore: () => {},
        onFinish: () => {}
    })
    const {
        CheckoutData,
        getCheckoutData,
        postCheckoutData,
        CheckoutPatronData,
        getSpecificPatronData,
    } = propsUseCheckout({
        onBefore: onCheckoutBefore,
        onFinish: onCheckoutFinish,
    })

    useEffect(() => {
        if (borrowernumber)
            getBorrowerData({
                borrowernumber: borrowernumber
            })
    }, [borrowernumber])

    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])

    useEffect(() => {
        refBorrowerCardnumber.current = inputBorrowerCardnumber
        if(clear_input && refBorrowerCardnumber.current=== ""){
            // actionRef_patron.current.reloadAndRest()
            set_clear_input(false)
        }
    }, [inputBorrowerCardnumber])
    useEffect(() => {
        refItemBarcode.current = inputItemBarcode
        if(clear_input && refItemBarcode.current === ""){
            // actionRef_item.current.reloadAndRest()
            set_clear_input(false)
        }
    }, [inputItemBarcode])

    useEffect(() => {
        set_borrower_data(CheckoutPatronData)
    }, [CheckoutPatronData])
    useEffect(() => {
        set_item_data(SpecificItemData)
    }, [SpecificItemData])

    const borrower = BorrowerData?.find(_ => true)
    return <>
        
        <ResizablePanelGroup direction="horizontal">
            <ResizablePanel>
                <Row className="mb-2" gutter={[8, 16]} align={"middle"}>
                    <Col span={24}></Col>
                    <Col className="text-left" span={6} >{t("cardnumber")}：</Col>
                    <Col span={12} >
                        <Input 
                            value={inputBorrowerCardnumber}
                            onChange={(e) => {
                                setInputBorrowerCardnumber(e.target.value)
                            }}
                        />
                    </Col>
                </Row>
                <div style={{ marginBottom: "24px", marginLeft: "6px" }} hidden={false}>
                    <div style={{ marginBottom: "36px" }} hidden={false}>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">編號(系統帳號): </Label></Col><Col span={16}>{borrower_data?.find(_ => true)?.staff_serial_name}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">姓名: </Label></Col><Col span={16}>{borrower_data?.find(_ => true)?.staff_name}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">英文名: </Label></Col><Col span={16}>{borrower_data?.find(_ => true)?.staff_english_name}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">性別: </Label></Col><Col span={16}>{borrower_data?.find(_ => true)?.gender_name}</Col></Row>
                        {/* <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('borrowernumber')}: </Label></Col><Col span={16}>{borrower_data?.find(_ => true)?.borrowernumber}</Col></Row> */}
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('cardnumber')}: </Label></Col><Col span={16}>{borrower_data?.find(_ => true)?.cardnumber}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('branchcode')}: </Label></Col><Col span={16}>{borrower_data?.find(_ => true)?.branchcode}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('branchname')}: </Label></Col><Col span={16}>{borrower_data?.find(_ => true)?.branchname}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('borrowercategory')}: </Label></Col><Col span={16}>{borrower_data?.find(_ => true)?.categoryname}</Col></Row>
                        <>
                        {/* <ProTableOt
                            showSearch={false}
                            reloadButton={false}
                            manageColumnsButton={false}
                            showMode={"page"}
                            actionRef={actionRef_patron}
                            columns={columns_patron}
                            request={async (params = {}, sort, filter) => {
                                let newParams = {};
                                newParams = {
                                    ...newParams,
                                    borrowernumber: refBorrowerCardnumber.current,
                                };
                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                return getSpecificPatronData({
                                    ...newParams
                                })
                            }}
                            rowSelection={{ type: "" }}
                            scroll={{ x: "100vw" }}
                        /> */}
                        </>
                    </div>
                </div>
            </ResizablePanel>
            <ResizableHandle />
            <ResizablePanel>
                <Row className="mb-2" gutter={[8, 16]} align={"middle"}>
                    <Col span={24}></Col>
                    <Col className="text-left" span={6} >{t("barcode")}：</Col>
                    <Col span={12} >
                        <Input 
                            value={inputItemBarcode}
                            onChange={(e) => {
                                setInputItemBarcode(e.target.value)
                            }}
                        />
                    </Col>
                    <Col span={6} >
                        <Button 
                            onClick={() => {
                                refBorrowerCardnumber.current = inputBorrowerCardnumber
                                refItemBarcode.current = inputItemBarcode
                                // actionRef_patron.current.reloadAndRest()
                                // actionRef_item.current.reloadAndRest()
                                getSpecificPatronData({
                                    cardnumber: refBorrowerCardnumber.current
                                })
                                getSpecificItemData({
                                    barcode: refItemBarcode.current === "" ? -1 : refItemBarcode.current
                                })
                                if(refBorrowerCardnumber.current !== "" && refItemBarcode.current !== "") set_search(true)
                                setLoading(true)
                                setTimeout(() => {
                                    setLoading(false)
                                }, 500)
                            }}
                        >{t("search")}
                        </Button>
                    </Col>
                </Row>
                <div style={{ marginBottom: "24px", marginLeft: "6px" }} hidden={false}>
                    <div style={{ marginBottom: "36px" }} hidden={false}>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('biblionumber')}: </Label></Col><Col span={16}>{item_data?.find(_ => true)?.bib_biblionumber}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('itemnumber')}: </Label></Col><Col span={16}>{item_data?.find(_ => true)?.item_itemnumber}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('collection_type')}: </Label></Col><Col span={16}>{item_data?.find(_ => true)?.item_itype_description}</Col></Row>
                        <Row>
                            <Col className="text-left" span={8} ><Label htmlFor="terms">{t('title')}: </Label></Col>
                            <Col span={16}>
                                <Row>
                                    <Col span={24}>{item_data?.find(_ => true)?.bib_title}</Col>
                                    <Col span={24}>{item_data?.find(_ => true)?.bib_subtitle}</Col>
                                    <Col span={24}>{item_data?.find(_ => true)?.bib_author}</Col>
                                    <Col span={24}>{item_data?.find(_ => true)?.item_barcode}</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('barcode')}: </Label></Col><Col span={16}>{item_data?.find(_ => true)?.item_barcode}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('collection_branch')}: </Label></Col><Col span={16}>{item_data?.find(_ => true)?.item_branchname_home}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">{t('current_location')}: </Label></Col><Col span={16}>{item_data?.find(_ => true)?.item_branchname_holding}</Col></Row>
                        <Row><Col className="text-left" span={8} ><Label htmlFor="terms">預約人數: </Label></Col><Col span={16}>{item_data?.find(_ => true)?.reserve.length}</Col></Row>
                        <>
                        {/* <ProTableOt
                            showSearch={false}
                            reloadButton={false}
                            manageColumnsButton={false}
                            showMode={"page"}
                            actionRef={actionRef_item}
                            columns={columns_item}
                            request={async (params = {}, sort, filter) => {
                                let newParams = {};
                                newParams = {
                                    ...newParams,
                                    itemnumber: refItemBarcode.current === "" ? -1 : refItemBarcode.current
                                };
                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                return getItemData({
                                    ...newParams
                                })
                            }}
                            rowSelection={{ type: "" }}
                            scroll={{ x: "100vw" }}
                        /> */}
                        </>
                    </div>
                </div>
            </ResizablePanel>
        </ResizablePanelGroup>
        <div style={{ marginBottom: "24px" }} hidden={false}>
            <Row className="mb-2" gutter={[8, 16]} align={"middle"}>
                <Col>
                    {permission_level === 1 ? 
                    <Button variant="outline" 
                        onClick={() => {
                            if(inputBorrowerCardnumber === "" || inputItemBarcode === "") message.error("讀者編號以及書目編號必填")
                            else {
                                postCheckoutData([{
                                    // borrowernumber: inputBorrowerCardnumber,
                                    // itemnumber: inputItemBarcode,
                                    borrowernumber: borrower_data?.find(_ => true)?.borrowernumber,
                                    itemnumber: item_data?.find(_ => true)?.item_itemnumber, 
                                    biblionumber: item_data?.find(_ => true)?.bib_biblionumber
                                }])
                            }
                        }}
                        disabled={!search}
                    >{t("checkout")}</Button>
                    : <></>}
                </Col>
                <Col>
                    <Button variant="outline"
                        onClick={() => {
                            setInputBorrowerCardnumber("")
                            setInputItemBarcode("")
                            set_borrower_data([])
                            set_item_data([])
                            set_clear_input(true)
                        }}
                    >{t("clear")}
                    </Button>
                </Col>
            </Row>
            <hr />
        </div>

        <CheckoutSettingModal
            axiosMode={axiosMode}
            propsOpen={modalOpen}
            propsSetOpen={setModalOpen}
            propsForm={form}
            propsLoading={modalLoading}
            propsSetLoading={setModalLoading}
            onFinish={onFormFinish}
            customFormItems={customFormItems}
        />
        <ProTableOt
            actionRef={actionRef}
            columns={columns}
            check={check}
            setCheck={setCheck}
            headerTitle={<></>}
            rowKey={propsRowKey}
            request={async (params = {}, sort, filter) => {
                // setAxiosMode("get")
                let newParams = {};
                let order = setOrders(sort)
                newParams = {
                    // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                    ...newParams,
                    order,
                    size: params.pageSize,
                    cur_page: params.current,
                    custom_filter_value: params.keyword ?? "",
                    custom_filter_key: custom_filter_key,
                    // borrowernumber: borrowernumber,
                    // cardnumber: "001"
                    // "categorycode": "TEST",
                };
                newParams = setParamsFilter({
                    ...newParams,
                });
                // setPageSize(params?.pageSize ?? 20)
                // return getCheckoutHistoryData({
                //     ...newParams
                // })
                // return getCheckoutData({
                //     ...newParams
                // })
                return getItemData({
                    ...newParams
                })
            }}
            extra_columns={extra_columns}
            set_extra_columns={set_extra_columns}
            manage_columns={true}
            rowSelection={{
                type: "checkbox",
                selectedRowKeys: selectedRowKeys,
                selectedRowsInfo: selectedRowsInfo,
                setSelectedRowKeys: setSelectedRowKeys,
                setSelectedRowsInfo: setSelectedRowsInfo,
                ...rowSelection,
                // onSelectAll: rowSelection?.onSelectAll,
                // onSelect: rowSelection?.onSelect,
                // onChange: rowSelection?.getCheckboxProps

            }}
            // modalOpen={modalOpen}
            // setModalOpen={setModalOpen}
            scroll={{
                x: "100vw"
            }}
            toolBarRender={() => toolBarRender([
                // <Button
                //     type={'primary'}
                //     onClick={() => handleAddRow()}
                // >
                //     {t('post_checkout')}
                // </Button>,
                // <Button
                //     variant={"batchDelete"}
                //     onClick={() => handleDeleteRow()}
                // >
                //     {t('delete_multiple')}
                // </Button>,
            ])}
            propsUseData={() => {
                return {
                    postData: postCheckoutData,
                    // patchData: postCheckoutData,
                    // deleteData: deleteCheckoutHistoryData,
                }
            }}
            PropsPatchForm={
                <CheckoutSettingForm
                    // propsForm={form}
                    // propsShowKeys={propsShowKeys}
                    keyPrefix={keyPrefix}
                    customFormItems={customFormItems}
                />
            }
            propsPatchonFinish={({ axiosMode, status }) => {
                if (status === "success") {
                    actionRef.current.reload()
                } else {

                }
            }}
            propsPatchOnBefore={() => { }}
            // 目前沒有修改借閱的API
            // propsPatch
            // 借閱只能一本一次一個人借閱，所以無法批次
            // propsPost
            // 借閱時應該是不會有刪除紀錄的
            // propsDelete
            propsPatchProcess={(item) => {
                return ({
                    ...item,
                    issue_date_due: dayjs(item?.issue_date_due),
                })
            }}
            propsWidth={1000}
        />
        {/* <Row gutter={[8, 8]}>
            <Col>
                <Button onClick={CheckIn} variant='outline' disabled={selectedRowsInfo.length === 0}><Icon.Checkin />{t("return_selected_items")}</Button>
            </Col>
            <Col>
                <Button onClick={Renew} variant='outline' disabled={selectedRowsInfo.length === 0}><Icon.Renew />{t("renew_selected_items")}</Button>
            </Col>
            <Col hidden>
                <Button onClick={() => { Renew() }} variant='outline' ><Icon.RenewAll />{t("renew_all_items")}</Button>
            </Col>
        </Row> */}
    </>
}

export default CheckoutSettingProTableOt


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([]);
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    };
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: "DESC",
                });
            } else {
                return JSON.stringify({
                    column: key,
                    type: "ASC",
                });
            }
        });
        return newOrders;
    };
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders,
    };
};


const Icon = () => { }
Icon.Checkin = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="16"
            version="1.1"
            viewBox="0 0 384 448"
        >
            <g stroke="none" strokeOpacity="1" transform="translate(0 -604.362)">
                <path
                    fillOpacity="1"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeWidth="64"
                    d="M0 988.362h384v64H0z"
                ></path>
                <path
                    fillRule="evenodd"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeWidth="1"
                    d="M160 604.362v192l-96-96v80l128 128 128-128v-80l-96 96v-192h-64z"
                ></path>
            </g>
        </svg>
    );
}
Icon.Renew = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="#000"
                fillRule="evenodd"
                d="M12 6c-3.31 0-6 2.69-6 6h3l-4 4-4-4h3c0-4.42 3.58-8 8-8 1.57 0 3.03.46 4.26 1.24L14.8 6.7A5.87 5.87 0 0012 6zm3 6l4-4 4 4h-3c0 4.42-3.58 8-8 8a7.93 7.93 0 01-4.26-1.24L9.2 17.3c.83.45 1.79.7 2.8.7 3.31 0 6-2.69 6-6h-3z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}
Icon.RenewAll = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <g fill="#373737" strokeWidth="0.829" color="#000">
                <path
                    d="M8 11.141l-5.859-3.14 2.395-1.284-1.07-.574L0 8.001l8 4.286 8-4.286-3.465-1.858-1.068.574L13.861 8z"
                    style={{ InkscapeStroke: "none" }}
                ></path>
                <path
                    d="M8 14.854l-5.859-3.14 2.395-1.285-1.07-.573L0 11.714 8 16l8-4.286-3.465-1.858-1.068.573 2.394 1.285zM8 0L0 4.286l8 4.285 8-4.286zm0 1.146l5.86 3.14L8 7.426l-5.859-3.14z"
                    style={{ InkscapeStroke: "none" }}
                ></path>
            </g>
        </svg>
    );
}